import { Anchor } from '@zillow/constellation-10';

import type React from 'react';

type Props = {
  children: React.ReactNode;
  escape?: boolean;
  // Link component from react-router or next.js
  link?: React.ComponentType<React.PropsWithChildren<{ to: string }>>;
  name?: string;
  path: string | null;
  target?: string;
  title?: string;
  useAbsolutePaths?: boolean;
  onClick?: (event?: React.MouseEvent<HTMLElement, MouseEvent> | undefined) => void | null;
};

const AdaptiveAnchor = ({
  children,
  escape = false,
  link: Link,
  path,
  target = '_self',
  title,
  useAbsolutePaths = false,
  onClick,
}: Props) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (onClick) {
      onClick(event);
    }
  };

  const useLink = !useAbsolutePaths && !escape && Link && target === '_self';

  return useLink && Link ? (
    <Anchor onClick={handleClick} asChild>
      <Link data-testid="AdaptiveAnchor-Link" to={path ?? ''} aria-label={title} aria-labelledby={title}>
        {children}
      </Link>
    </Anchor>
  ) : (
    <Anchor
      data-testid="AdaptiveAnchor-Anchor"
      href={path ?? ''}
      onClick={handleClick}
      aria-label={title}
      aria-labelledby={title}
      title={title}
      target={target}
      css={{ width: '100%', textDecoration: 'none' }}
    >
      {children}
    </Anchor>
  );
};

export default AdaptiveAnchor;
